{
    "Capability": "Vermogen",
    "CapabilityEnabled": "Ingeschakeld",
    "AvailableTelServers": "Welke types telefonieserver zijn beschikbaar?",
    "AvailableLicences": "Welke typen sitelicenties zijn beschikbaar?",
    "Broadworks": "Cisco Breedwerken",
    "Webex": "Webex Bellen",
    "LegacyTelephony": "Legacy ^^ (Broadsoft M6, Panasonic, Siemens)^^",
    "Legacy": "Erfenis ^^(EEN, Aanwezigheid, Lite, 1000, 2000)^^",
    "Enterprise": "Onderneming",
    "Teams": "MS Teams",
    "MaxTelsysCount": "Maximum aantal telefonieservers in deze CME",
    "NAME": "CMECapabilities",
    "CxAnalytics": "CX-analyse",
    "CxIntegration": "CX-integratie"
}